/* eslint-disable no-param-reassign */
import { add, remove } from "shared/lib/arrayUtils"
import {
  ProjectsAPIMutationType,
  projectsAPIMutations
} from "shared/types/ProjectMutations"

import { PayloadAction } from "@reduxjs/toolkit"

import { RequestReducerState } from "./types"

function setupProjectRequestState(
  state: RequestReducerState,
  projectID: string
) {
  if (!state.requests.PROJECTS[projectID]) {
    state.requests.PROJECTS[projectID] = Object.fromEntries(
      projectsAPIMutations.map(mutation => [mutation, [] as string[]])
    ) as Record<ProjectsAPIMutationType, string[]>
  }
}

export function handleStartProjectRequest(
  state: RequestReducerState,
  action: PayloadAction<{
    projectID: string
    requestType: ProjectsAPIMutationType
    requestID: string
  }>
) {
  const { projectID, requestID, requestType } = action.payload
  setupProjectRequestState(state, projectID)
  state.requests.PROJECTS[projectID][requestType] = add(
    requestID,
    state.requests.PROJECTS[projectID][requestType]
  )
}

export function handleFinishProjectRequest(
  state: RequestReducerState,
  action: PayloadAction<{
    projectID: string
    requestType: ProjectsAPIMutationType
    requestID: string
  }>
) {
  const { projectID, requestID, requestType } = action.payload
  setupProjectRequestState(state, projectID)
  state.requests.PROJECTS[projectID][requestType] = remove(
    requestID,
    state.requests.PROJECTS[projectID][requestType]
  )
}
